import { createStore, applyMiddleware, Store } from "redux";
import createSagaMiddleware from 'redux-saga'
import { createLogger }     from 'redux-logger';

import reducers             from './reducers/application';
import actions              from './actions/application';
import rootSaga             from './sagas/application';
import StoreWrap            from "./general/store_wrap";
import Page                 from "./general/page";
import Location             from './general/location';
import onload               from 'utilities/onload';
import { Scopes }           from './scopes';

const loggerMiddleware = createLogger();
const sagaMiddleware   = createSagaMiddleware();

import ResponseThen         from "utilities/response_then";

import NotifyStandard           from "components/notify/standard";
import NotifyCommand            from "components/notify/command";
import DialogBase               from "components/dialog/base";
import {
  dom as domFontawesome,
  library as fasLibrary,
  IconPack } from '@fortawesome/fontawesome-svg-core'

export const reduxStore = createStore(
  reducers,
  applyMiddleware(
    loggerMiddleware,
    sagaMiddleware
  )
);
sagaMiddleware.run(rootSaga);

import { ableProHorizontal } from 'vendor/able-pro';

export default class App {
  static fontawsomeIcons   = [];
  static store: StoreWrap  = new StoreWrap(reduxStore);
  static actions           = actions;
  static Page              = Page;
  static onload            = onload;
  static location          = new Location();
  static notify            = new NotifyStandard();
  static command           = new NotifyCommand();
  static dialog            = new DialogBase();
  static responseThen      = new ResponseThen();
  static currentPayload    = undefined;
  static init(){
    domFontawesome.watch();
    App.readyFontawesome();
    if (document['attachEvent'] ? document.readyState === "complete" : document.readyState !== "loading"){
      App.ready()
    } else {
      document.addEventListener('DOMContentLoaded', App.ready);
    }
    // onload.add(App.loaded);
  }
  static ready(){
    App.notify.init();
    App.command.init();
    App.dialog.init();
    App.responseThen.init();
    onload.addBefore(App.reflesh);
    onload.add(App.loaded);
  }
  static reflesh(){
    window['ableProInitialized'] = false;
    // window['Waypoint'].destroyAll();
    App.store.dispatch(App.actions.data.clear());
    App.store.dispatch(App.actions.planner.clear());
    App.store.dispatch(App.actions.planner.clear_lines());
    App.store.dispatch(App.actions.planner.clear_tasks());
    App.store.dispatch(App.actions.planner.clear_memos());
    App.store.dispatch(App.actions.planner.clear_taskables());
    App.store.dispatch(App.actions.planner.clear_locations());
    App.store.dispatch(App.actions.planner.clear_schedules());
    App.store.dispatch(App.actions.planner.clear_orders());
  }
  static loaded(e){
    if(e == null){ return; }
    $('.loader-bg').fadeOut();
    // console.log(!window['ableProInitialized'])
    // if(!window['ableProInitialized']){
      // window['ableProInitialized'] = true;
    ableProHorizontal();
    // App.readyFontawesome();
    // }
    // $("#pcoded" ).pcodedmenu();
    // FontAwesomeUtil.i2svg(document.body);
  }
  static updateData(data, exts = []) {
    let dispatch = App.store.dispatch;
    if(data.data){ dispatch(App.actions.data.update(data.data)); }
    let planner = App.actions.planner;
    for(let i=0; i < exts.length; i++){
      if(exts[i] == 'orders'){ dispatch(planner.orders(data.orders)) }
      if(exts[i] == 'schedules'){ dispatch(planner.schedules(data.schedules)) }
      if(exts[i] == 'memos'){ dispatch(planner.memos(data.memos)) }
      if(exts[i] == 'taskables'){ dispatch(planner.taskables(data.taskables)) }
    }
  }
  static updatePlanner(data){
    let dispatch = App.store.dispatch;
    let planner = App.actions.planner;
    if(data.data){ dispatch(App.actions.data.update(data.data)); }
    if(data.planner){   dispatch(planner.update(data.planner)); }
    if(data.memos){     dispatch(planner.memos(data.memos)); }
    if(data.locations){ dispatch(planner.locations(data.locations)); }
    if(data.taskables){ dispatch(planner.taskables(data.taskables)); }
    if(data.tasks){     dispatch(planner.tasks(data.tasks)); }
    if(data.schedules){ dispatch(planner.schedules(data.schedules)); }
    if(data.lines){     dispatch(planner.lines(data.lines)); }
    if(data.orders){    dispatch(planner.orders(data.orders)); }
  }
  static authenticity_token(){
    return App.store.getState().data.authenticity_token
  }

  static setCurrentPayload(payload){
    this.currentPayload = payload;
  }

  static addFontAwesomeIcons(...args: any[]){
    App.fontawsomeIcons = args
  }
  static readyFontawesome(){
    fasLibrary.add(<IconPack><unknown>App.fontawsomeIcons);
  }
}
